import {useState, useEffect} from 'react';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Insert = () => {

    const navigate = useNavigate()

    const { addData } = useEntityCrud('PersonOrderPolicy/RegisterPerson');
    const { readData } = useEntityCrud('Business/GetAllBusiness');

    const [businesses,setBusinesses] = useState([])
    const [businessId,setBusinessId] = useState(0)
    const [personnel,setPersonnel] = useState([])
    const [result,setResult] = useState(false)
    const [resultData,setResultData] = useState('')

    useEffect(() => {
        readData().then(({ data }) => {
            if(data.status)
                setBusinesses([...data.result.map(business => ({label: business.title,value: business.id}))])
        })
    },[])

    const downloadSampleFile = () => {
        const csvContent = 'data:text/csv;charset=utf-8;';
        const csvFile = 'کد ملی,این سطر را تغییر ندهید. در ستون اول هر سطر یک کد ملی وارد کنید\n'
        const BOM = '\uFEFF'
        const blob = new Blob([BOM + csvFile],{ type: csvContent })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','policy-personnel-sample.csv');
        link.click();
    }

    const handlePersonnelFile = e => {
        const file = e.target.files[0];
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = () => {
                const personnelList = []
                const csvFile = reader.result;
                csvFile.split('\n').map(item => {                    
                    const nationalCode = item.replace(',','').replace('\r','').replace('\n','')
                    if(/^\d+$/.test(nationalCode)){
                        personnelList.push({
                            businessId: businessId.value,
                            nationalCode: nationalCode.toString().padStart(10,'0')
                        })
                    }
                });
                if(personnelList.length > 0)
                    setPersonnel(personnelList);
                else
                    toast.error('فایل بارگذاری شده نامعتبر است')
            };
        });
    }

    const submitPersonnel = () => {
        addData(personnel).then(({ data }) => {
            if(data.status){
                toast.success('لیست پرسنل با موفقیت بارگذاری شد');
                setResult(true)
                setResultData(data.result)
            }
        })
    }

    const downloadResult = () => {
        const csvContent = 'data:text/csv;charset=utf-8;';
        let csvFile = 'کد ملی,کسب و کار,نتیجه\n';
        const businessTitle = businessId.label;
        resultData.map(item => {
            csvFile += `${item.nationalCode},${businessTitle},${item.resultMessage}\n`;
        })
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvFile],{ type: csvContent });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','policy-personnel-sample.csv');
        link.click();
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">درون ریزی لیست استفاده کنندگان اسنپ فود</div>
                <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3" style={{position: 'relative'}}>
                        <div className="form-group">
                            <label>کسب و کار</label>
                            {!!businessId && <i className="fe fe-x clear-select-btn" onClick={() => setBusinessId(0)}></i>}
                            <ReactSelect label="شرکت"
                                options={businesses}
                                value={businessId}
                                onChange={e => setBusinessId(e)}
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    {!!businessId && <>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>فایل لیست پرسنل</label>
                                <input className="form-control" accept="text/csv" type="file" onChange={handlePersonnelFile} />
                            </div>
                        </div>
                        <div className="col-md-7" style={{marginTop: 30}}>
                            <button className="btn btn-primary me-2" onClick={downloadSampleFile}>دریافت فایل نمونه</button>
                            {!!personnel.length && <button className="btn btn-success me-2" onClick={submitPersonnel}>ثبت پرسنل</button>}
                            {result && <button className="btn btn-dark me-2" onClick={downloadResult}>دریافت فایل نتیجه</button>}
                        </div>
                    </>}
                </div>
            </div>
        </div>
    )
}

export default Insert